import { render } from "./UserDetail.vue?vue&type=template&id=169c7fff&ts=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"

import "./UserDetail.vue?vue&type=style&index=0&id=169c7fff&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__